import { C } from '../constants';

function Cell({ n, label }) {
  return (
    <span className="inline-flex items-baseline gap-1">
      <span style={{ fontWeight: 700, fontSize: '0.95rem', color: C.white }}>
        {String(n).padStart(2, '0')}
      </span>
      <span style={{ fontSize: '0.6rem', color: C.textDim, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
        {label}
      </span>
    </span>
  );
}

export default function CountdownPill({ ended, days, hrs, mins, secs }) {
  if (ended) {
    return (
      <span
        className="inline-flex items-center gap-2"
        style={{
          color:           C.pink,
          backgroundColor: 'rgba(255,77,158,0.1)',
          border:          `1px solid ${C.pink}55`,
          padding:         '6px 14px',
          borderRadius:    999,
          fontSize:        '0.72rem',
          fontWeight:      600,
          letterSpacing:   '0.16em',
          textTransform:   'uppercase',
        }}
      >
        Voting closed
      </span>
    );
  }

  return (
    <span
      className="inline-flex items-center gap-2.5"
      style={{
        background:          C.cardBg,
        backdropFilter:      'blur(12px)',
        WebkitBackdropFilter:'blur(12px)',
        border:              `1px solid ${C.border}`,
        padding:             '7px 14px',
        borderRadius:        999,
        boxShadow:           '0 0 24px rgba(0,229,255,0.08)',
      }}
    >
      <span
        style={{
          display:      'inline-block',
          width:        7,
          height:       7,
          borderRadius: '50%',
          background:   C.cyan,
          boxShadow:    `0 0 12px ${C.cyan}`,
          animation:    'tnpoll-pulse 1.6s ease-in-out infinite',
        }}
      />
      <Cell n={days} label="d" />
      <span style={{ color: C.textDimmer }}>:</span>
      <Cell n={hrs}  label="h" />
      <span style={{ color: C.textDimmer }}>:</span>
      <Cell n={mins} label="m" />
      <span style={{ color: C.textDimmer }}>:</span>
      <Cell n={secs} label="s" />
    </span>
  );
}
